/* ADD POLL */
export const ADD_POLL_ANSWER = "ADD_POLL_ANSWER"
export const ADD_POLL_ANSWER_SUCCESS = "ADD_POLL_ANSWER_SUCCESS"
export const ADD_POLL_ANSWER_CLEAN = "ADD_POLL_ANSWER_CLEAN"
export const ADD_POLL_ANSWER_ERROR = "ADD_POLL_ANSWER_ERROR"
